import { WidgetNames } from '@finxone-platform/shared/sys-config-types';

export const emailNestedWidgets = {
  verifyButton: {
    name: WidgetNames.BUTTON,
    widgetConfigDisplayName: 'Verify Button Styling',
    attributes: {
      widgetProperties: {
        textContent: 'Verify',
      },
      elementsConfig: [],
      css_config: {
        borderRadiusBottomRight: 6,
        borderRadiusBottomLeft: 0,
        borderRadiusTopRight: 6,
        borderRadiusTopLeft: 0,
        borderWidth: 0,
        borderUnit: 'px',
        marginUnit: 'px',
        paddingUnit: 'px',
        fontSize: 16,
        fontUnit: 'px',
        borderRadiusUnit: 'px',
        textAlignment: 'center',
        textFont: 'var(--font-family)',
        backGroundColor: 'var(--color-surface)',
        color: 'var(--color-on-background)',
      },
    },
  },
};
